//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from "../layouts/Header.vue";

import Footer from "../layouts/Footer.vue";
import HeroPageBanner from "../components/HeroPageBanner.vue";

export default {
  name: "partners",
  data() {
    return {
      partners: [
        {
          id: 1,
          title: "Besurance China Limited",
          description:
            "Besurance China reimagines technology for its transformative power to create new business models of insurance and empower communities",
          photoSrc: "/images/besurance-logo.svg",
          website: "https://www.besurancecorp.com/",
          linkedin: "https://www.linkedin.com/company/besurance-corporation/"
        },
        {
          id: 2,
          title: "Netawork Limited",
          description:
            "Netawork are a B2B consultancy that has strong connection with design and manufacturing partners with 40+ years of experience in many business sectors around the world. Netawork will work with you with the smartest solutions and shape your business towards a promising future. Netawork can help in any industries- from smart cities, medical & healthcare, consumer electronics & appliances, HVAC & industrial.",
          photoSrc: "images/netawork-logo.png",
          website: "https://www.netaworkltd.com/",
          linkedin: "https://www.linkedin.com/company/netawork-limited"
        },
        {
          id: 3,
          title: "Scalelab",
          description:
            "The Scalelab is a B2B lead generation company based in Hong Kong and Singapore, helping sales teams to continuously meet with potential clients.",
          photoSrc: "images/TSL logo coloured.png",
          website: "https://www.thescalelab.com/",
          linkedin: "https://www.linkedin.com/company/the-scalelab/"
        }
      ]
    };
  },
  components: {
    Header,
    Footer,
    HeroPageBanner
  },
  methods: {},
  head: {
    title: "Partners | Mazecare",
    meta: [
      {
        hid: "description",
        name: "description",
        content:
          "Mazecare works closely with partners to deliver exceptional products & services to our customers."
      }
    ]
  }
};
